import { ReactElement } from 'react';
import { decode } from 'html-entities';
import { Link } from '@99designs/emu';
import { FormattedReactMessage } from '@99designs/frontend-components/i18n';

interface Props {
    answer: string;
    linksReplacements: Record<string, string>;
}

export function FAQFormattedAnswer({ answer, linksReplacements }: Props) {
    const replacements: Record<string, ReactElement> = {};

    Object.entries(linksReplacements).forEach(([key, value]) => {
        replacements[key] = <Link href={value} openInNewTab />;
    });

    return <FormattedReactMessage message={decode(answer)} replacements={replacements} />;
}
